"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UccCliReducedOfferDecision = exports.MerchantCliApprovalOutcome = void 0;
// Outcome the approve screen polls for after consent: the re-underwrite + CoreCard apply run in a background job.
var MerchantCliApprovalOutcome;
(function (MerchantCliApprovalOutcome) {
    MerchantCliApprovalOutcome["processing"] = "processing";
    MerchantCliApprovalOutcome["applied"] = "applied";
    MerchantCliApprovalOutcome["rejected"] = "rejected";
    MerchantCliApprovalOutcome["verifyIncome"] = "verifyIncome";
    // The income-verified re-run qualified a line below the merchant's request but above the account's current line:
    // the cardholder is shown the smaller increase to accept or decline (newLineSizeInDollars = the offered line,
    // previousLineSizeInDollars = the current line).
    MerchantCliApprovalOutcome["reducedOffer"] = "reducedOffer";
})(MerchantCliApprovalOutcome || (exports.MerchantCliApprovalOutcome = MerchantCliApprovalOutcome = {}));
// The cardholder's decision on a reduced offer (the smaller line the income-verified re-run qualified).
var UccCliReducedOfferDecision;
(function (UccCliReducedOfferDecision) {
    UccCliReducedOfferDecision["accept"] = "accept";
    UccCliReducedOfferDecision["decline"] = "decline";
})(UccCliReducedOfferDecision || (exports.UccCliReducedOfferDecision = UccCliReducedOfferDecision = {}));
